/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bubble_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is bubble size scaled?`)
};

const es_bubble_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se escala el tamaño de la burbuja?`)
};

const de_bubble_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie wird die Blasengröße skaliert?`)
};

const nl_bubble_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe wordt de belgrootte geschaald?`)
};

const fr_bubble_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment la taille des bulles est-elle mise à l'échelle ?`)
};

const it_bubble_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come viene scalata la dimensione della bolla?`)
};

const pt_br2_bubble_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como o tamanho da bolha é escalado?`)
};

const pt_bubble_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como é dimensionado o tamanho da bolha?`)
};

const ja_bubble_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バブルのサイズはどうスケールされますか？`)
};

const zh_bubble_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`气泡大小是如何缩放的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bubble_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bubble_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bubble_faq_q2", locale)
	if (locale === "en") return en_bubble_faq_q2(inputs)
	if (locale === "es") return es_bubble_faq_q2(inputs)
	if (locale === "de") return de_bubble_faq_q2(inputs)
	if (locale === "nl") return nl_bubble_faq_q2(inputs)
	if (locale === "fr") return fr_bubble_faq_q2(inputs)
	if (locale === "it") return it_bubble_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_bubble_faq_q2(inputs)
	if (locale === "pt") return pt_bubble_faq_q2(inputs)
	if (locale === "ja") return ja_bubble_faq_q2(inputs)
	return zh_bubble_faq_q2(inputs)
};